(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.initHomepageCarousels(root.document, root.Siema);
})(typeof window !== 'undefined' ? window : null, function () {
  // 首页产品轮播：使用独立 Siema 引擎，保留旧 index.js 的循环、拖拽、动画及按钮/圆点联动。
  function initHomepageCarousels(documentRoot, SiemaConstructor) {
    if (typeof SiemaConstructor !== 'function') return;
    var carousels = documentRoot.querySelectorAll('.as-carousel');

    Array.prototype.forEach.call(carousels, function (carousel) {
      var slideWrapper = carousel.querySelector('.as-carousel-slides');
      var slides = carousel.querySelectorAll('.as-carousel-slide');
      var indicators = carousel.querySelectorAll('.as-carousel-indicator');
      var previous = carousel.querySelector('.as-carousel-prev');
      var next = carousel.querySelector('.as-carousel-next');

      if (!slideWrapper || !slides.length) return;

      Array.prototype.forEach.call(slides, function (slide) { slide.style.display = 'block'; });

      function syncState(index) {
        var normalizedIndex = ((index % slides.length) + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (slide, slideIndex) {
          slide.classList.toggle('active', slideIndex === normalizedIndex);
        });
        Array.prototype.forEach.call(indicators, function (indicator, indicatorIndex) {
          if (indicator.parentElement) {
            indicator.parentElement.classList.toggle('active', indicatorIndex === normalizedIndex);
          }
          indicator.setAttribute('aria-current', indicatorIndex === normalizedIndex ? 'true' : 'false');
        });
      }

      var siema = new SiemaConstructor({
        selector: slideWrapper,
        loop: true,
        draggable: true,
        duration: 200,
        easing: 'ease-out',
        threshold: 20,
        onChange: function () { syncState(this.currentSlide); }
      });

      if (previous) previous.addEventListener('click', function () { siema.prev(); });
      if (next) next.addEventListener('click', function () { siema.next(); });
      Array.prototype.forEach.call(indicators, function (indicator, index) {
        indicator.addEventListener('click', function () {
          var targetIndex = Number(indicator.dataset.slideTo);
          siema.goTo(Number.isFinite(targetIndex) ? targetIndex : index);
        });
      });

      syncState(siema.currentSlide);
    });
  }

  return { initHomepageCarousels: initHomepageCarousels };
});
